jQuery.validator.setDefaults({
    highlight: function (element, errorClass) {
        if (element.type === 'text' || element.type === "password" || element.type === "textarea" || element.type === "select-one" || element.type === "radio" || element.type === "number") {
            $(element).closest('.required-input').addClass('usa-input-error');
            $(element).closest('.required-input').trigger('cssClassChanged');
            if (localStorage.action) {
                SetAlertsForValidationErrors();
            }
        }
    },
    unhighlight: function (element, errorClass, validClass) {
        if (element.type === 'text' || element.type === "password" || element.type === "textarea" || element.type === "select-one" || element.type === "radio" || element.type === "number") {
            var success = false;
            if ($(element).parent().hasClass('usa-input-error')) {
                success = true;
            }
            if (hasDateFieldErrors(element) === false) {
                $(element).closest('.required-input').removeClass('usa-input-error');
                if ($(element).closest(".required-input").find(".field-validation-error").length) {
                    $(element).closest(".required-input").find(".field-validation-error").removeClass("field-validation-error").addClass("field-validation-valid").text("");
                }
                $(element).closest('.required-input').trigger('cssClassChanged');
            }
            if (success === true) {
                $(element).addClass('usa-input-success');
            }
        }
    }
});

function hasDateFieldErrors(element) {
    var requiredInput = element.closest(".required-input");
    if (requiredInput && requiredInput.querySelectorAll(".usa-datefield").length > 0) {
        return requiredInput.querySelectorAll(".field-validation-error").length > 0;
    }
    return false;
}

//handle server-side validations
$(function () {
    CheckValidationErrors();
});

global.CheckValidationErrors = function() {
    $('.field-validation-error').each(function () {
        if (!$(this).parent().hasClass('usa-input-error')) {
            $(this).parent().addClass('usa-input-error');
            SetAlertsForValidationErrors();
        }
    });
}

global.SetAlertsForValidationErrors = function() {
    if ($('.usajobs-alert--error').length) {
        $('.usajobs-alert--error').attr("aria-hidden", "false");
        $('.usajobs-alert--success').attr("aria-hidden", "true");
        localStorage.removeItem("action");
        setTimeout(function () { $(window).scrollTop($('.usajobs-nav__body').position().top) }, 0);
    }
}
